import { Component } from "react";
import styles from "./bottom-info-modal.module.less";
import GlobalContext from "components/stores/global-context";
import {
  ECommerceHelper,
  EventAggregator,
  ProductStore,
  CartContextConsumer,
  extract,
  SecondaryButton,
  PrimaryButtonLink,
} from "@parksandresorts/core";

export default class BottomInfoModal extends Component {
  constructor(props) {
    super(props);

    this.jetshopConfig = ECommerceHelper.getJetshopConfig();
    this.headline = extract(props, "headline");
    this.productName = extract(props, "productName");
    this.body = extract(props, "body");
    this.defaultHeadline = extract(this.jetshopConfig, "defaultAddToCartNotificationHeadline");
    this.defaultBody = extract(this.jetshopConfig, "defaultAddToCartNotificationBody");
    this.defaultBodyWithProductName = this.replaceTemplateStringWithProductName(this.defaultBody, this.productName);
    this.toCheckoutLabel = extract(this.jetshopConfig, "jetshopCheckoutUrl.title");
    this.continueShoppingLabel = extract(this.jetshopConfig, "continueShoppingLabel");

    if (this.productName && this.body) {
      this.bodyWithProductName = this.replaceTemplateStringWithProductName(this.body, this.productName);
    }
  }

  isCartUpsellable(cartContext) {
    return (
      !cartContext.isUpsellVisited &&
      cartContext.upsellItems &&
      cartContext.upsellItems.length > 0 &&
      this.upsellPageUrl
    );
  }

  getCheckoutUrl(cartContext) {
    if (this.isCartUpsellable(cartContext)) {
      return this.upsellPageUrl;
    }
    return cartContext.getCheckoutUrl();
  }

  trackGoToCheckoutEvent(cartContext) {
    if (this.isCartUpsellable(cartContext)) {
      EventAggregator.publish("trackEvent", {
        category: "Bottom Info Modal",
        action: "Clicked button",
        label: "Upsale",
      });
    } else {
      const products = cartContext.products.map((product) => {
        const contentfulProduct = ProductStore.getProductByJetshopId(product.jetshopId);
        return {
          name: product.name,
          id: product.jetshopId,
          price: product.price,
          category:
            contentfulProduct && contentfulProduct.tags instanceof Array && contentfulProduct.tags.length
              ? contentfulProduct.tags[0].title
              : undefined,
          quantity: 1,
          glkId:
            contentfulProduct && contentfulProduct.productData.glkId
              ? parseInt(contentfulProduct.productData.glkId)
              : null,
        };
      });

      EventAggregator.publish("trackEvent", {
        category: "Bottom Info Modal",
        action: "Clicked button",
        label: "Checkout",
      });

      EventAggregator.publish("trackEcommerce", {
        event: "checkout",
        action: {
          checkout: {
            actionField: { step: 1 },
            products: products,
          },
        },
      });
    }
  }

  replaceTemplateStringWithProductName(body, productName) {
    if (!productName) {
      return body;
    }

    if (!(body && productName)) {
      return;
    }

    return body.replace(/%productName%/gi, productName);
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <h3 className={styles.headline}>{this.headline ? this.headline : this.defaultHeadline}</h3>
        <p className={styles.body}>
          {this.bodyWithProductName ? this.bodyWithProductName : this.defaultBodyWithProductName}
        </p>
        <div className={styles.buttonWrapper}>
          <SecondaryButton
            complementary
            isFullWidth
            label={this.continueShoppingLabel}
            className={["waves-effect", styles.continueShopping].join(" ")}
            onClick={() => {
              this.context.setValue({ animateCloseInformationModal: true });
              EventAggregator.publish("trackEvent", {
                category: "Bottom Info modal",
                action: "Clicked button",
                label: "Continue shopping",
              });
            }}
          />
          <CartContextConsumer>
            {(cartContext) => (
              <div onClick={() => this.trackGoToCheckoutEvent(cartContext)}>
                <PrimaryButtonLink
                  isFullWidth
                  label={this.toCheckoutLabel}
                  url={this.getCheckoutUrl(cartContext)}
                  className={["waves-effect", styles.toCheckout].join(" ")}
                />
              </div>
            )}
          </CartContextConsumer>
        </div>
      </div>
    );
  }
}

BottomInfoModal.contextType = GlobalContext;
